import { OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TreeTableDataModel } from '../../../models/prime-tree-table.model';
import { OpenWorkEvent } from '../../../events/open-work-event';
import { ViewerDisplayEvent } from '../../../events/viewer-display-event';
import { CategorizationChangeEvent } from '../../../events/categorization-change-event';
import { WorkClassChildrenModel } from 'e5core-angular-services';

export class E5coreUiWorkRelatedItemsBaseComponent implements OnInit {
  @Input() treeData : any;
  @Input() length : number;
  @Input() labels: string[];
  @Input() pagesizes: number[];
  @Input() readonly : boolean;
  @Input() childWorkItemCategories: WorkClassChildrenModel[];
  @Input() createButtonText : string;
  @Input() showCreateChildButton : boolean;
  @Input() showDefinedChildrenOnly : boolean;

  @Output() workItemSelectEvent = new EventEmitter<OpenWorkEvent>();
  @Output() pageEvent = new EventEmitter();
  @Output() attachmentSelectEvent = new EventEmitter<ViewerDisplayEvent>();
  @Output() categorisationChangeEvent = new EventEmitter<CategorizationChangeEvent>();
  @Output() createChildWorkItemEvent = new EventEmitter();

  constructor() {
  }

  ngOnInit(): void {
  }

  public onWorkItemSelect(treeTableDataModel : TreeTableDataModel) : void {
    this.workItemSelectEvent.emit({workId: treeTableDataModel.id, reference: null, type: "related"});
  }

  public onAttachmentSelect(treeTableDataModel : TreeTableDataModel) : void {
    this.attachmentSelectEvent.emit({workId: treeTableDataModel.id, type: "E5SharepointAttachment", attachmentId: null, fullUrl: null, name: null});
  }

  public createChildWorkItem() : void {
    this.createChildWorkItemEvent.emit();
  }

  public onCategorizationChange($event: CategorizationChangeEvent) : void {
    if ($event.category1Id > 0 && $event.category2Id > 0 && $event.category3Id > 0)
      this.categorisationChangeEvent.emit($event);
  }

  public selectChildCategory($event) : void {
    this.categorisationChangeEvent.emit({category1Id: $event.value.category1Id, category2Id: $event.value.category2Id, category3Id: $event.value.category3Id});
  }

  public onPageEvent(event) : void {
    this.pageEvent.emit(event);
  }
}